import { Tooltip } from '@/components';
import { Color } from '@/types/ColorLibraryModel';
import { isColorDark } from '@/utils';
import classNames from 'classnames';
import { useMemo } from 'react';

const ColourStripColour = ({
  color,
  isSelected,
  onClick,
}: {
  color: Color;
  isSelected: boolean;
  onClick?: (color: Color) => void;
}) => {
  const isDark = useMemo(() => isColorDark(color.hexCode), [color.hexCode]);
  return (
    <Tooltip
      placement="top"
      content={color.displayName}
      className="min-w-[15%] flex-1 md:min-w-[5%] [&_.tooltip-container]:!-top-10"
    >
      <div
        className={classNames(
          'h-[200px] w-full cursor-pointer bg-cover bg-center bg-no-repeat transition-all',
          color.effect === 'Metallic' && 'bg-metallic',
          color.effect === 'Lustre' && 'bg-lustre',
          color.effect === 'Chrome' && 'bg-chrome',
        )}
        style={{
          backgroundColor: `#${color.hexCode}`,
          border: isSelected ? `2px solid ${isDark ? 'white' : 'black'}` : 'none',
        }}
        onClick={onClick ? () => onClick(color) : undefined}
      />
    </Tooltip>
  );
};

export default ColourStripColour;
